import { DropCard } from '../components/DropCard';
import { trendingDrops } from '../data/mock';

/**
 * Drops — every active drop across the marketplace. Live drops surface first;
 * sold-out editions fall to the back. Original order is otherwise preserved.
 */
export function Drops() {
  const live = trendingDrops.filter((d) => d.edition.sold < d.edition.total);
  const soldOut = trendingDrops.filter((d) => d.edition.sold >= d.edition.total);
  const drops = [...live, ...soldOut];

  return (
    <main className="min-h-[100dvh] bg-provny-white text-provny-black dark:bg-provny-ink dark:text-provny-white">
      <div className="mx-auto max-w-7xl px-6 pb-20">
        <header className="pt-10">
          <h1 className="font-heading text-4xl font-black tracking-tight">Drops</h1>
          <p className="mt-2 text-provny-muted">Limited originals, live now. When they're gone, they're gone.</p>
        </header>

        <div className="mt-8 grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-4">
          {drops.map((drop) => (
            <DropCard key={drop.id} drop={drop} />
          ))}
        </div>
      </div>
    </main>
  );
}
